export default {
    common: {
        title: 'Contenuto IA',
        socialPlanner: 'Pianificatore sociale',
        blog: 'Blog',
        funnel: 'imbuto',
        website: 'Sito web',
        mediaLibrary: 'Biblioteca multimediale',
        email: 'Email',
        words: 'Parole',
        variations: 'Varianti',
        thisIsPaidService: "Questa funzione è un servizio a pagamento e comporterà costi in base all'utilizzo",
        all: 'Alle',
    },
};
